module.exports = __webpack_public_path__ + "img/kalmar_no.051cac06.png";